import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import FormikButton from '../../components/formik/FormikButton';
import FormikSelect from '../../components/formik/FormikSelect';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import { rtGetListData } from '../../store/slices/listSlice';

const validate = Yup.object().shape({
    service: Yup.string().required().label('Service'),
});

export default function ScanQRScreen() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { services } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('services', 'services'));
    }, [dispatch]);

    const filteredServices = services?.map(({ id, name }) => ({
        value: id,
        label: name,
    }));

    return (
        <Screen title="Scan QR">
            <Grid item xs={12}>
                <Typography
                    className="text-center fw-bold"
                    sx={{ mb: 4 }}
                    variant="h6"
                >
                    AUTOMATED ATTENDANCE RECORDING
                </Typography>
                <Typography sx={{ mb: 4, mx: 2 }} variant="h6">
                    Only the authorized church members are allowed to use this
                    feature
                </Typography>
                <div className="d-flex flex-column">
                    <Form
                        validationSchema={validate}
                        initialValues={{ service: '' }}
                        onSubmit={({ service }) =>
                            navigate(`/scan-qr/${service}`)
                        }
                    >
                        <FormikSelect
                            name="service"
                            data={filteredServices}
                            label="Service"
                        />
                        <FormikButton variant="contained">Scan</FormikButton>
                    </Form>
                </div>
            </Grid>
        </Screen>
    );
}
